export const ADD_OBJECT_BUTTONS_WALL = [
  // `add` buttons
  {
    type: "object",
    category: "wall-objects",
    isAddObjectButton: true,
    groups: ["year 1", "year 2", "year 3", "year 4", "year 5", "year 6"],
  },
];
